<script setup lang="ts">
import { VIcons } from '@/shared/ui'
import './assets/style.scss'

const props = defineProps({
  type: {
    type: String,
    default: 'radio_button_unchecked',
  },
  status: {
    type: Number,
    default: 1,
  },
  power: {
    type: Number,
    default: 1,
  },
  selected: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div class="v-map-marker">
    <div
      class="v-map-marker__location"
      :class="{
        'v-map-marker__location_disconnected': status === 0,
        'v-map-marker__location_errors': status === 3,
        'v-map-marker__location_warning': status === 2,
        'v-map-marker__location_selected': selected,
      }"
    />

    <VIcons
      class="v-map-marker__type"
      :class="{
        'v-map-marker__type_light': power !== 1,
      }"
      bold
      :type="type"
    />
  </div>
</template>
